import { Form, FormikFormProps } from "formik";
import React from "react";

export const BB8Form = (props: FormikFormProps) => {
    return <Form { ...props }>{ props.children }</Form>;
};

export default BB8Form;
